var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control datetimepicker-input",attrs:{"type":"text","title":_vm.placeholder,"placeholder":_vm.placeholder,"id":_vm.id,"autocomplete":"off","data-toggle":"datetimepicker","data-target":_vm.target}})
}
var staticRenderFns = []

export { render, staticRenderFns }